import type { SvgProps } from '@/types/svgs/svg-types';

const SiteWideJackpotSlots = ({ lineColor }: SvgProps) => (
    <svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.67902 3.2479C3.27265 3.2479 2.94322 3.57733 2.94322 3.9837C2.94322 4.39008 3.27265 4.71951 3.67902 4.71951H4.28204L2.95323 12.6924C2.88642 13.0932 3.15721 13.4723 3.55805 13.5391C3.9589 13.6059 4.338 13.3352 4.40481 12.9343L5.87642 4.10467C5.91198 3.89132 5.85186 3.67313 5.71206 3.5081C5.57225 3.34307 5.36692 3.2479 5.15063 3.2479H3.67902Z"
            fill="url(#paint0_linear_10538_76286)"
        />
        <path
            d="M8.09384 3.2479C7.68747 3.2479 7.35804 3.57733 7.35804 3.9837C7.35804 4.39008 7.68747 4.71951 8.09384 4.71951H8.69686L7.36805 12.6924C7.30124 13.0932 7.57203 13.4723 7.97287 13.5391C8.37372 13.6059 8.75282 13.3352 8.81963 12.9343L10.2912 4.10467C10.3268 3.89132 10.2667 3.67313 10.1269 3.5081C9.98707 3.34307 9.78174 3.2479 9.56545 3.2479H8.09384Z"
            fill="url(#paint1_linear_10538_76286)"
        />
        <path
            d="M11.7729 3.9837C11.7729 3.57733 12.1023 3.2479 12.5087 3.2479H13.9803C14.1966 3.2479 14.4019 3.34307 14.5417 3.5081C14.6815 3.67313 14.7416 3.89132 14.7061 4.10467L13.2345 12.9343C13.1676 13.3352 12.7885 13.6059 12.3877 13.5391C11.9869 13.4723 11.7161 13.0932 11.7829 12.6924L13.1117 4.71951H12.5087C12.1023 4.71951 11.7729 4.39008 11.7729 3.9837Z"
            fill="url(#paint2_linear_10538_76286)"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.6593 15.0208V12.0775C18.472 12.0775 19.1309 11.4187 19.1309 10.6059V9.13433H22.8099C23.2163 9.13433 23.5457 8.8049 23.5457 8.39853V4.5939C24.4031 4.29087 25.0173 3.47322 25.0173 2.5121C25.0173 1.29298 24.029 0.304688 22.8099 0.304688C21.5908 0.304688 20.6025 1.29298 20.6025 2.5121C20.6025 3.47322 21.2167 4.29087 22.0741 4.5939V7.66272H19.1309V6.19111C19.1309 5.37837 18.472 4.71951 17.6593 4.71951V1.77629C17.6593 0.963548 17.0004 0.304688 16.1877 0.304688H1.47161C0.658861 0.304688 0 0.963548 0 1.77629V15.0208C0 15.8335 0.65886 16.4924 1.47161 16.4924H16.1877C17.0004 16.4924 17.6593 15.8335 17.6593 15.0208ZM16.1877 1.77629H1.47161L1.47161 15.0208H16.1877V1.77629Z"
            fill="url(#paint3_linear_10538_76286)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_10538_76286"
                x1="-5.35556"
                y1="0.304688"
                x2="19.1701"
                y2="26.8448"
                gradientUnits="userSpaceOnUse">
                <stop stopColor={lineColor ?? '#61019B'} />
                <stop offset="1" stopColor={lineColor ?? '#005FC8'} />
            </linearGradient>
            <linearGradient
                id="paint1_linear_10538_76286"
                x1="-5.35556"
                y1="0.304688"
                x2="19.1701"
                y2="26.8448"
                gradientUnits="userSpaceOnUse">
                <stop stopColor={lineColor ?? '#61019B'} />
                <stop offset="1" stopColor={lineColor ?? '#005FC8'} />
            </linearGradient>
            <linearGradient
                id="paint2_linear_10538_76286"
                x1="-5.35556"
                y1="0.304688"
                x2="19.1701"
                y2="26.8448"
                gradientUnits="userSpaceOnUse">
                <stop stopColor={lineColor ?? '#61019B'} />
                <stop offset="1" stopColor={lineColor ?? '#005FC8'} />
            </linearGradient>
            <linearGradient
                id="paint3_linear_10538_76286"
                x1="-5.35556"
                y1="0.304688"
                x2="19.1701"
                y2="26.8448"
                gradientUnits="userSpaceOnUse">
                <stop stopColor={lineColor ?? '#61019B'} />
                <stop offset="1" stopColor={lineColor ?? '#005FC8'} />
            </linearGradient>
        </defs>
    </svg>
);

export default SiteWideJackpotSlots;
